import { render, staticRenderFns } from "./receiveableLimitCheck.vue?vue&type=template&id=4481026a&scoped=true&"
import script from "./receiveableLimitCheck.vue?vue&type=script&lang=js&"
export * from "./receiveableLimitCheck.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4481026a",
  null
  
)

export default component.exports